/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {baseBlue, headerGray, tableHeaderGray} from "./colors";

const headerHeight = 13
const SIDEBAR_WIDTH_COLLAPSED = 100;
const SIDEBAR_WIDTH_EXPANDED = 250
const sidebarItemHoverColor = '#0a58ca'
const sidebarItemFontSize = 18


const theme = {
  font: {
    size: 14,
    button: {
      size: 12
    }
  },
  layout: {
    sidebar: {
      backgroundColor: baseBlue,
      height: `100vh`,
      collapsedWidth: `${SIDEBAR_WIDTH_COLLAPSED}px`,
      expandedWidth: `${SIDEBAR_WIDTH_EXPANDED}px`,
      collapseTransition: '250ms',
      body: {
        menuItem: {
          hoverColor: sidebarItemHoverColor,
          fontSize: `${sidebarItemFontSize}px`,
        }
      },
      footer: {
        collapseButton: {
          hoverColor: sidebarItemHoverColor,
          // hoverColor: '#909090',
          color: 'white'
        }
      },
    },
    header: {
      backgroundColor: baseBlue,
      height: `${headerHeight}vh`,
    },
  },
  apps: {
    ObjectDefinitions: {},
    VehiclePrograms: {},
    Admin: {}
  }
}

const OLD_TABLE_WITH_HEADER_BODY_HEIGHT = `calc(100vh - ${theme.layout.header.height} - 56px)`

export {theme, OLD_TABLE_WITH_HEADER_BODY_HEIGHT}
